import React from "react";

export const Pricing = () => {
  const pricingPlans = [
    {
      title: "Starter",
      price: "$250",
      period: "per month",
      users: "Up to 1 users",
      features: [
        "Unlimited Incident Entry",
        "Location Hierarchy",
        "Employee Structure",
        "6 Standard Incident Types",
        "Email Claim Submission",
        "Customizable Incident Forms",
        "Incident Notifications",
        "Peak Standard Support"
      ],
      featured: false
    },
    {
      title: "Professional",
      price: "$1250",
      period: "per month",
      users: "Up to 10 users",
      features: [
        "Everything from the Starter plan",
        "Claim Management",
        "Unlimited Claim Files",
        "Incident and Claim Matching",
        "Claim Financial Summaries and Transactions",
        "Standard Analytics",
        "Safety Forms",
        "Peak Professional Support"
      ],
      featured: true
    },
    {
      title: "Premium",
      price: "$2500",
      period: "per month",
      users: "Up to 25 users",
      features: [
        "Everything from the Professional plan",
        "API Integrations",
        "Advanced Analytics",
        "Scheduled Reporting",
        "Branding",
        "Claim Automations",
        "Peak Premium Support"
      ],
      featured: false
    },
    {
      title: "Enterprise",
      price: "Custom",
      period: "",
      users: "Unlimited users",
      features: [
        "Everything from the Premium plan",
        "Custom API Integrations",
        "Advanced Analytics",
        "Custom Reporting",
        "Support - Dedicated Manager",
        "Custom Branding"
      ],
      featured: false,
      isCustom: true
    }
  ];

  const handleStartTrialClick = () => {
    const signUpUrl = import.meta.env.VITE_WEBPAGE_URL + '/sign-up';
    window.open(signUpUrl, '_blank');
  };

  return (
    <div id="pricing" className="section" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="section-title">
          <h2>Pricing</h2>
          <p>Please choose the plan that's best for you!</p>
        </div>
        <div className="pricing-description">
          <p>Start every plan with a free 30-day trial, and grow and adjust as you go.</p>
          <p>Make the Climb toward Peak Risk Management.</p>
        </div>
        <div className="row">
          {pricingPlans.map((plan, i) => (
            <div key={`${plan.title}-${i}`} className="col-xs-12 col-md-6 col-lg-3">
              <div className={`pricing-card ${plan.featured ? 'featured' : ''} ${plan.isCustom ? 'custom-pricing' : ''}`}>
                {plan.featured && <div className="popular-badge">Most Popular</div>}
                <div className="pricing-header">
                  <h3 className="pricing-title">{plan.title}</h3>
                  <div className="pricing-price">
                    {plan.isCustom ? (
                      <span className="custom-price">Custom</span>
                    ) : (
                      <>
                        <span className="price-amount">{plan.price}</span>
                        <span className="pricing-period">{plan.period}</span>
                      </>
                    )}
                  </div>
                  <p className="pricing-users">{plan.users}</p>
                </div>
                <div className="pricing-features-container">
                  <div className="features-header">
                    <span className="features-title">Features included:</span>
                  </div>
                  <ul className="pricing-features">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="feature-item">
                        <i className="fa fa-check feature-check"></i>
                        <span className="feature-text">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <button 
                  className={`btn ${plan.isCustom ? 'btn-secondary' : 'btn-primary'}`}
                  onClick={handleStartTrialClick}
                >
                  {plan.isCustom ? 'Contact Us' : 'Start your free trial now'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
